import _ from "lodash";
import React, { ReactElement, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLangAppLiterals } from "../../../../redux/slices/literalsSlice";

import { getAllLanguageLiterals } from "../../../../api";

import Loading from "../../loading/loading";
import { CURRENT_LOCALE } from "../../../../helper/locale-utils";

const LiteralHandler: React.FC<any> = (props): ReactElement => {
  const dispatch = useDispatch();
  const currentLocale = useSelector((state: any) => state.tenant.selectedLanguage);
  const refreshRequestId = useSelector((state: any) => state.literals.refreshRequestId);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (CURRENT_LOCALE) loadLangs(CURRENT_LOCALE);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [CURRENT_LOCALE, currentLocale, refreshRequestId]);

  async function loadLangs(lang: string) {
    try {
      setIsLoading(true);
      const literals = await getAllLanguageLiterals(lang);
      if (literals) {
        const literalsUnion = _.extend({}, literals);
        dispatch(setLangAppLiterals(literalsUnion, () => setIsLoading(false)));
      } else setIsLoading(false);
    } catch (e) {
      console.error(e, "Loading literals from FE json");
      setIsLoading(false);
    }
  }

  return <>{isLoading ? <Loading id="literals-handler" /> : props.children}</>;
};

export default LiteralHandler;
